/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import TermsOfServiceLawFirmPageMeta from "./TermsOfServiceLawFirmPageMeta";
import Container from "../../../../../components/Container/Container";
import Layout from "../../../../Layouts/Layout";
import TermsOfServiceLawFirm from "../../../../../components/TermsOfService/TermsOfServiceLawFirm/TermsOfServiceLawFirm";

const TermsOfServiceLawFirmPage = () => {
  return (
    <Layout backgroundType={"landingpage"}>
      <TermsOfServiceLawFirmPageMeta />
      <Container showPaddingBlock={false}>
        <TermsOfServiceLawFirm />
      </Container>
    </Layout>
  );
};

export default TermsOfServiceLawFirmPage;
